module.exports = __webpack_public_path__ + "img/logo.5e1a9e6a.svg";